module.exports = __webpack_public_path__ + "img/refresh.bdd03cc7.svg";